import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'selector-ciclo-calificaciones',
  template: `
      <ng-select style="z-index: 9999;" 
          name="ciclo"
          bindLabel="descripcion"
          bindValue="id"
          [(ngModel)]="ciclo"
          [options]="ciclos">
      </ng-select>
  `,
  styles: []
})
export class SelectorCicloCalificacionesComponent implements OnInit {
  ciclos: any
  ciclo: string
  constructor() { }

  ngOnInit() {
    this.ciclos = [
      {value:'1', label:'Año lectivo'},
      {value:'2', label:'Quimestre 1'},
      {value:'3', label:'Quimestre 2'},
      {value:'4', label:'Final '}
    ]
    this.ciclo = '3'

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/selector-ciclo-calificaciones.component.ts